import { useMemo } from "react";
import { View } from "react-native";
import empty_album_state from "src/assets/lottie/empty_album_state/empty_album_state.lottie";
import Lottie from "src/components/Lottie";
import StickersScattered from "src/components/StickersScattered";
import { useGatheringStore } from "src/contexts/GatheringContext";
import parseStickerTemplateUrl from "src/helpers/parseV0TemplateUrl/parseStickerTemplateUrl";
import GatheringUploadPhotosButton from "./GatheringUploadPhotosButton";

const NoPhotosUpload = ({ height }: { height: number }) => {
	const isSmall = height < 225;
	const stickerPack = useGatheringStore((state) => state.stickerPack);
	const stickers = useMemo(() => {
		if (!stickerPack || !stickerPack.stickers || stickerPack.stickers.length === 0) return null;
		return stickerPack.stickers.map((sticker) => ({
			url: parseStickerTemplateUrl({ readUrl: sticker.readUrl }),
		}));
	}, [stickerPack]);

	return (
		<View
			style={[
				{
					width: "100%",
					height: "100%",
					alignItems: "center",
					justifyContent: isSmall ? "flex-start" : "center",
					overflow: "hidden",
				},
			]}
		>
			{!isSmall && stickers ? (
				<StickersScattered
					stickers={stickers}
					style={{
						position: "absolute",
						width: "80%",
						height: "80%",
						overflow: "visible",
					}}
				/>
			) : (
				<Lottie
					source={empty_album_state}
					style={{
						position: "absolute",
						width: "80%",
						height: "80%",
					}}
				/>
			)}
			<GatheringUploadPhotosButton sizeVariant="Medium" />
		</View>
	);
};
export default NoPhotosUpload;
